//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PrivacyPolicy',
  props: {
    section: {
      type: Object,
      required: true,
    },
  },
}
